/**
 * オンライン薬局の ID。
 *
 * `domain/index.ts` で `export * as Consultation` 経由で公開されるため、
 * 利用側からは `Consultation.OnlinePharmacy.Au` のように参照される。
 *
 * shared_back 側の `OnlinePharmacy` と値・命名を揃えること。
 */
export const OnlinePharmacy = {
    /** 未指定 */
    Unspecified: 0,
    /** au 薬局 */
    Au: 1,
    /** Kiviaq 薬局 */
    Kiviaq: 2,
    /** ヨヤクスリ_Rakuten 薬局 */
    Rakuten: 3,
};
/**
 * オンライン薬局の表示ラベル（日本語）。
 *
 * clinic / CSV など多言語化不要な箇所で利用する。
 * patient は多言語化のため `t("reservationDetail.xxxPharmacyName")` を使用する。
 *
 * 型は `{ [k: number]: string }` として公開し、API から取得した
 * `number | undefined` を直接 index できるようにする。
 * `satisfies Record<OnlinePharmacy, string>` で全列挙値の網羅性を担保する。
 */
export const OnlinePharmacyLabel = {
    [OnlinePharmacy.Unspecified]: "",
    [OnlinePharmacy.Au]: "au薬局",
    [OnlinePharmacy.Kiviaq]: "Kiviaq薬局",
    [OnlinePharmacy.Rakuten]: "ヨヤクスリ薬局",
};
